import Environment from '@di-shared/features/environment/Environment';
import Eu from '@di-shared/features/safe-driving-vDSP/SafeDrivingAgreeBanner/.eu';
import Kr from '@di-shared/features/safe-driving-vDSP/SafeDrivingAgreeBanner/.kr';

export interface SafeDrivingAgreeBannerProps {
  vin: string;
}

export default function SafeDrivingAgreeBanner({vin}: SafeDrivingAgreeBannerProps) {
  return (
    <>
      <Environment.Kr>
        <Kr vin={vin} />
      </Environment.Kr>
      <Environment.Eu>
        <Eu vin={vin} />
      </Environment.Eu>
    </>
  );
}
